
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/academics",
      function () {
        return require("private-next-pages/academics.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/academics"])
      });
    }
  